export default __webpack_public_path__ + "static/media/Ies_panel_AngelesEscobedo.bb146b18.png";